module.exports = __webpack_public_path__ + "img/ic_community_white.672620d8.svg";